import React from 'react';
import MaterialPaper from '@material-ui/core/Paper';
import '../styles/Paper.scss';

const Paper = ({children}) => {
    return (
        <MaterialPaper className="paper" elevation={0} square={true}>{children}</MaterialPaper>
    );
};

export default Paper;
